import { supabase } from '../config/supabase';

export type ProviderScoreSnapshot = {
  match_event_id: string;
  team_id: string;
  score_status: 'Reported' | 'Confirmed';
  our_score: number;
  opponent_score: number;
  winner: 'Us' | 'Opponent';
  determination_method: string | null;
  captain_score_conflict: boolean;
  conflict_episode_key: string | null;
  checked_at: string;
};

export async function providerScoreWarningVisible(key: string, userId: string): Promise<boolean> {
  const { data, error } = await supabase.from('notification_dismissals')
    .select('snoozed_until').eq('notification_key', key).eq('dismissed_by', userId).maybeSingle();
  if (error) throw new Error(error.message);
  return !data || Boolean(data.snoozed_until && Date.parse(data.snoozed_until) <= Date.now());
}

export async function setProviderScoreWarningDisposition(key: string, userId: string, snoozeDays?: number): Promise<void> {
  if (snoozeDays !== undefined && (!Number.isInteger(snoozeDays) || snoozeDays < 1 || snoozeDays > 30)) throw new Error('Invalid snooze period.');
  const { error } = await supabase.from('notification_dismissals').upsert({
    notification_key: key,
    notification_type: 'official_provider_score_disagreement',
    dismissed_at: new Date().toISOString(),
    dismissed_by: userId,
    snoozed_until: snoozeDays === undefined ? null : new Date(Date.now() + snoozeDays * 86400000).toISOString(),
  }, { onConflict: 'notification_key,dismissed_by' });
  if (error) throw new Error(error.message);
}
